import MainTitleWobble from './wobbleTypes/MainTitleWobble';
import LinkBoxWobble from './wobbleTypes/LinkBoxWobble';

export { MainTitleWobble, LinkBoxWobble };
